import { useMutation, useQuery } from "@tanstack/react-query";
import { ScreeningSelectAllRequest } from "modules/Volunteer/AssigningStudyModule/StudyScreening/helper/studyscreening.types";
import { studyscreeningApiService } from "./studyscreening.api";


export const useStudyScreeningService = ({
    otherid,
    searchText,
    pageNumber = 1,
    pageSize = 10,
    studyid,
}: {
    otherid?: number | null;
    searchText?: string | null;
    pageNumber?: number;
    pageSize?: number;
    studyid?: number | null;
} = {}) => {
    const SelectAllQuery = useQuery({
        queryKey: [
            "screening-selectAll",
            { otherid, searchText, pageNumber, pageSize, studyid },
        ],
        queryFn: () =>
            studyscreeningApiService.getSelectAllData({
                volunteerid: otherid ?? null,
                searchtext: searchText ?? null,
                currentpage: pageNumber,
                pagesize: pageSize,
                status: "A",
                studyid: studyid!,
            } as ScreeningSelectAllRequest),
    });

    const InsertMutation = useMutation({
        mutationFn: studyscreeningApiService.insertData,
    });

    const UpdateMutation = useMutation({
        mutationFn: studyscreeningApiService.updateData,
    });

    const DeleteMutation = useMutation({
        mutationFn: studyscreeningApiService.deleteData,
    });

    const DecisionMutation = useMutation({
        mutationFn: studyscreeningApiService.updateDecision,
    });

    return {
        SelectAllQuery,
        InsertMutation,
        UpdateMutation,
        DeleteMutation,
        DecisionMutation,
    };
};
